  //roles for frontdesk
  // 2 --- companyAdmin
  // 3 --- companyEmployees
  // 4 --- companyFinance
export const rolesEnum = {
  employee: 3,
  frontdeskRoles: [2, 4],
};

export const dutyTypeEnum = {
  airpotTransfer: 1,
  rental: 2,
  outstation: 3,
  outstationRoundTrip: 4,
};

export const tripDutyTypeEnum = {
  airpotTransfer: 4,
  rental: 5,
  outstation: 6,
  outstationRoundTrip: 7,
};

export const billingType = {
  billToCreditCard: 1,
  billToCompany: 2,
  billToBoth: 3,
};

export const minimumBookingHours = {
  minHours: 2
}

export const rateCardFiltersEnum = {
  cityType: "cityType",
  dutyType: "dutyType",
  carType: "carType"
}

